// @flow
import { path } from 'ramda'
import { getRadioChannelGenres } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_RADIO_CHANNEL_GENRES = 'radioChannels/FETCH_GENRES'

const fetchRadioChannelGenresAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_RADIO_CHANNEL_GENRES,
    payload: getRadioChannelGenres(publicApi, serviceSpec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchRadioChannelGenres = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchRadioChannelGenresAction(serviceSpec))

  const state = getState()
  const expires = path(['channelGenres', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchRadioChannelGenresAction(serviceSpec))
}
